import React from 'react';

const Orientation = () => {
    return <div>Orientation</div>;
};

export default Orientation;
